import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
          <div
            className="pointer-events-none absolute inset-0 opacity-20"
            style={{
              backgroundImage:
                "radial-gradient(circle at 15% 20%, oklch(var(--background-50) / 0.6), transparent 40%), radial-gradient(circle at 85% 80%, oklch(var(--accent-500) / 0.7), transparent 45%)",
            }}
            aria-hidden="true"
          />
          <div className="relative">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-4xl">
              下一部好看的韩漫，正在等着你
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-primary-100 md:text-base">
              无论你偏爱热血奇幻、甜涩校园还是华美古风，韩国漫画大全都为你整理好了最值得追读的专题佳作。
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
              >
                立即开逛
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}